"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactUse = require("react-use");

var _reactFocusLock = _interopRequireDefault(require("react-focus-lock"));

var _DqBackdrop = _interopRequireDefault(require("../../overlays/DqBackdrop/DqBackdrop"));

var _DqPortal = _interopRequireDefault(require("../../utils/DqPortal/DqPortal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Dialog window
 */
const DqDialog = ({
  maxWidth = "md",
  scroll,
  children,
  backdropProps,
  handleOnOpen,
  handleOnClose
}) => {
  (0, _reactUse.useKeyPressEvent)("Escape", () => {
    handleOnClose();
  });
  (0, _react.useEffect)(() => {
    if (handleOnOpen) {
      handleOnOpen();
    }
  }, []); // Workaround to avoid purge of this classes on build

  const maxWidthClass = {
    sm: "dq-max-w-sm",
    md: "dq-max-w-md",
    lg: "dq-max-w-lg",
    xl: "dq-max-w-xl",
    "2xl": "dq-max-w-2xl"
  };
  return /*#__PURE__*/_react.default.createElement(_DqPortal.default, {
    className: "root-dialog"
  }, /*#__PURE__*/_react.default.createElement(_DqBackdrop.default, _extends({}, backdropProps, {
    onClick: handleOnClose
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "dq-h-full dq-flex dq-items-center dq-justify-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "dialog",
    "aria-labelledby": "dialog-title",
    className: (0, _classnames.default)(`dq-relative dq-flex dq-flex-col dq-w-full ${maxWidthClass[maxWidth]} dq-bg-white dq-rounded`, {
      "dq-max-h-full dq-overflow-y-auto": scroll
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "presentation",
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/_react.default.createElement(_reactFocusLock.default, {
    autoFocus: true,
    returnFocus: true
  }, children))))));
};

DqDialog.defaultProps = {
  backdropProps: {},
  maxWidth: "md",
  scroll: false,
  handleOnOpen: () => {}
};
var _default = DqDialog;
exports.default = _default;